import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // auth
    isLogin: false
  },
  mutations: {},
  actions: {},
  modules: {}
});
